// No longer used, kept as a dummy plugin to avoid errors when it is loaded by old code.
(function () {
  'use strict';

  var global = tinymce.util.Tools.resolve('tinymce.PluginManager');

  function Plugin () {
    global.add('blockquotepatch', function (editor) {
      return {};
    });
  }

  Plugin();
}());
